import { formatRelativeDate } from '@littlebird/ui-utils';
import { observer } from 'mobx-react-lite';

import { type AgentInboxMessage } from '@/backendApis';
import { InitialsAvatar } from '@/components/ui/Avatar';
import { Badge } from '@/components/ui/Badge';
import { XStack, YStack } from '@/components/ui/layout/layout';

import { useMessageParties } from './agent-inbox-parties';

type AgentInboxMessageRowProps = {
  message: AgentInboxMessage;
  onOpen: () => void;
};

export const AgentInboxMessageRow = observer(
  ({ message, onOpen }: AgentInboxMessageRowProps) => {
    const { counterpart, counterpartName, counterpartLabel } =
      useMessageParties(message);
    return (
      <XStack
        role="button"
        tabIndex={0}
        onClick={onOpen}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onOpen();
          }
        }}
        className="cursor-pointer items-start gap-3 rounded-xl px-3 py-2.5 transition-colors hover:bg-surface-hover focus-ring"
      >
        <InitialsAvatar
          name={counterpartName}
          seed={counterpart}
          className="mt-0.5 size-8 text-[0.6875rem]"
        />
        <YStack className="min-w-0 flex-1 gap-0.5">
          <XStack className="items-baseline gap-3">
            <p className="min-w-0 flex-1 truncate text-sm font-medium text-foreground">
              {counterpartLabel}
            </p>
            <span className="shrink-0 text-xs text-foreground-muted">
              {formatRelativeDate(message.created_at)}
            </span>
          </XStack>
          <XStack className="items-center gap-2">
            <p className="min-w-0 flex-1 truncate text-sm text-foreground-muted">
              {message.subject || '(no subject)'}
            </p>
            {message.kind === 'signup' && (
              <Badge variant="secondary">Sign-up code</Badge>
            )}
          </XStack>
        </YStack>
      </XStack>
    );
  }
);
